 const slides = gsap.utils.toArray(".carousel-slide");
    const prev = document.querySelector(".prev");
    const next = document.querySelector(".next");
    let currentIndex = 0;

    // overwrite CSS to prevent native scrolling
    gsap.set(".carousel", { "scroll-snap-type": "none" });
    // display the prev / next buttons and progress text
    gsap.set(".carousel-nav", { display: "block" });

    slides.forEach((slide, i) => {
        slide.classList.add("carousel-slide-abs");
        gsap.set(slide, { opacity: (i === 0 ? 1 : 0) });
      });

      next.addEventListener("click", () => changeSlide( 1 ));
    prev.addEventListener("click", () => changeSlide( -1 ));
    function changeSlide( dir ) {
  
        // current slide's outro
        gsap.to(slides[currentIndex], { opacity: 0, ease: "power3" });
        
        // dir parameter will increment or decrement the current number
        // if the value is below or above the range, wrap() will return a number within the range, creating a loop
       currentIndex = gsap.utils.wrap(0, slides.length, (currentIndex += dir));
        
        // new current slide's intro
        gsap.to(slides[currentIndex], { opacity: 1, ease: "power3.inOut" });
        
        // update the progress text
     //   gsap.set(".carousel-nav div", { innerText: `${currentIndex + 1}/${slides.length}` });
      }